import React from "react";
import PropTypes from "prop-types";

const Footer = () => {
	return (
		<footer className="site-footer">
			<div className="container">
				<div className="row gap-y align-items-center">
					<div className="col-12 col-lg-6 offset-lg-3">
						<ul className="nav nav-primary nav-hero">
							<li className="nav-item">
								{new Date().getFullYear()} &copy; <a href="https://www.kuchkrtehai.com"> Kuchkrtehai.com </a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	);
};

Footer.displayName = "Footer";

Footer.propTypes = {
	className: PropTypes.string
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js